import { NgModule } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { cn } from './i18n/zh-CN';
import { tw } from './i18n/zh-TW';
import { en } from './i18n/en-US';
import { vi } from './i18n/vi';

@NgModule({
    imports: [TranslateModule.forRoot()],
    exports: [TranslateModule]
})
export class HomeLangModule {
    constructor(
        private translate: TranslateService
    ) {
        this.translate.setTranslation('zh-CN', cn);
        this.translate.setTranslation('zh-TW', tw);
        this.translate.setTranslation('en-US', en);
        this.translate.setTranslation('vi', vi);

    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/home-lang.module.ts